// Exports
export default {
	"modal": "modal_O7hJl",
	"container": "container_-5zhA",
	"header": "header_+im41",
	"headerButtonContainer": "headerButtonContainer_yYNzN",
	"headerText": "headerText_Nfw+s",
	"content": "content_mwyV8",
	"contentScrollable": "contentScrollable_+VjJV",
	"footer": "footer_Wg9sw"
};
